export default "__VITE_ASSET__U0qri4zUpkK0i5QhPa58Mw__"